import React from "react";
import { Link } from "react-router-dom";

// ─── Sayfa ────────────────────────────────────────────────────────────────────
const TarihcePage: React.FC = () => (
  <div className="min-h-screen bg-bg-page">

    {/* ── Hero ── */}
    <div className="bg-gradient-to-br from-[#0F172A] to-[#1A2540] py-16 text-white">
      <div className="w-full px-6 xl:px-16 text-center">
        <div className="text-brand-gold text-sm font-semibold uppercase tracking-wider mb-2">
          Tarihçe ve Hafıza
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3">Derneğimizin Hikâyesi</h1>
        <p className="text-white/70 max-w-2xl mx-auto leading-relaxed">
          Trabzon'dan Bursa'ya uzanan bir gönül köprüsü — kuruluşumuzdan bugüne.
        </p>
      </div>
    </div>

    {/* ── Derneğin Hikâyesi ── */}
    <section className="py-20 bg-bg-surface">
      <div className="w-full px-6 xl:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 items-center mb-12">
            <div className="space-y-4 text-text-muted leading-relaxed text-justify">
              <p>
                2005 yılında, Bursa'ya yerleşmiş bir grup Trabzonlunun girişimiyle hayata geçen derneğimiz,
                bugün 500'ü aşkın üyesiyle şehrin en köklü hemşehri kuruluşlarından biri hâline gelmiştir.
                Kuruluşumuzun temelinde yalnızca nostalji değil; memleket bağını yaşatmak, yeni gelenlere
                el uzatmak ve gençlere rehberlik etmek yatar.
              </p>
              <p>
                Yıllar içinde onlarca kültür etkinliği, yüzlerce aile buluşması ve genç kuşaklara sunulan
                burs ve kariyer destekleriyle büyüyen derneğimiz; Trabzon ile Bursa arasında gönül köprüsü
                olmaya devam etmektedir. Her etkinliğimizde horonumuzu, kemençemizi ve hamsi sofralarımızı
                Bursa'ya taşıyoruz.
              </p>
              <p>
                Derneğimiz; kültürel kimliği yaşatma, hemşehrilik dayanışmasını güçlendirme ve toplumsal
                katkı üretme misyonuyla her geçen gün daha da büyümekte, Trabzon sevdalılarını bir araya
                getirmektedir.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { sayi: "500+", etiket: "Üye", ikon: "fa-users", renk: "bg-brand-bordo" },
                { sayi: "20+", etiket: "Yıl", ikon: "fa-calendar", renk: "bg-brand-blue" },
                { sayi: "100+", etiket: "Etkinlik", ikon: "fa-star", renk: "bg-brand-gold" },
                { sayi: "50+", etiket: "Burs Öğrencisi", ikon: "fa-graduation-cap", renk: "bg-brand-bordo" },
              ].map((s) => (
                <div key={s.etiket} className="card text-center py-6">
                  <div className={`w-12 h-12 ${s.renk} rounded-full flex items-center justify-center mx-auto mb-3`}>
                    <i className={`fa-solid ${s.ikon} text-white text-lg`} />
                  </div>
                  <div className="text-2xl font-extrabold text-text-primary">{s.sayi}</div>
                  <div className="text-text-muted text-xs mt-1 uppercase tracking-wider">{s.etiket}</div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>

    {/* ── Haber ── */}
    <section className="py-20 bg-bg-page">
      <div className="w-full px-6 xl:px-16">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-brand-bordo/10 text-brand-bordo text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
              <i className="fa-solid fa-newspaper" /> Haber
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-text-primary leading-snug">
              Kahvaltı Programımızı Gerçekleştirdik
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center">
            <img
              src="/images/haberler/kahvalti-programi.jpg"
              alt="Kahvaltı Programı"
              className="w-full rounded-2xl shadow-sm object-cover"
              style={{ maxHeight: "420px" }}
            />
            <div className="space-y-4 text-text-muted leading-relaxed text-justify text-sm">
              <p>
                Bursa Trabzon Kültür ve Yardımlaşma Derneği olarak, Başkanımız Orhan AYGÜN
                öncülüğünde Yönetim Kurulu üyelerimizin katılımıyla düzenlediğimiz kahvaltı
                programını birlik ve beraberlik içerisinde gerçekleştirdik.
              </p>
              <p>
                Samimi bir ortamda gerçekleştirilen organizasyonumuzda, BTSO Yönetim Kurulu
                Başkanı Sayın İbrahim Burkay ile Milletvekilimiz Sayın Zekeriya Birkan bizleri
                ziyaret ederek programımıza değer katmışlardır.
              </p>
              <p>
                Nazik ziyaretleri ve kıymetli sohbetleriyle bizleri onurlandıran Sayın İbrahim
                Burkay'a ve Sayın Zekeriya Birkan'a teşekkür ediyor; birlik, beraberlik ve
                dayanışma içerisinde şehrimize ve hemşehrilerimize değer katacak çalışmaları
                sürdüreceğimizi ifade ediyoruz.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* ── CTA ── */}
    <section className="py-16 bg-gradient-to-br from-brand-bordo-dark via-brand-bordo to-[#6B1535]">
      <div className="w-full px-6 xl:px-16 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
          Bu Tarihin Parçası Ol
        </h2>
        <p className="text-white/75 mb-8 max-w-lg mx-auto leading-relaxed">
          Trabzon'u seven, bu köklü kültürü yaşatmak isteyen herkese kapımız açık.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link to="/destek/uyelik"
            className="bg-white text-brand-bordo font-bold px-8 py-3 rounded-lg hover:bg-white/90 transition-colors flex items-center gap-2">
            Üyelik Başvurusu <i className="fa-solid fa-arrow-right text-xs" />
          </Link>
          <Link to="/kurumsal/hakkimizda"
            className="border-2 border-white/50 text-white font-bold px-8 py-3 rounded-lg hover:bg-white/10 transition-colors">
            Hakkımızda
          </Link>
        </div>
      </div>
    </section>

  </div>
);

export default TarihcePage;